<template>
<div style=width:100%>

    <div class="display-flex">
        <!-- Uses custom component https://github.com/devstark-com/vue-textarea-autosize -->
        <textarea-autosize v-model="currentComment.text" :placeholder="placeHolder" :min-height="30" :max-height="350" type="text" ref="commentBox" class="quick-input white-background add-comment"
            @keydown.native.ctrl.68.prevent="demoData" @keydown.native.meta.68.prevent="demoData" @keypress.native.exact.enter.prevent="saveComment"
        />
        <div style="width:1px;margin-left:-6px">
            <v-menu offset-y left>
                <template v-slot:activator="{ on }">
                    <v-icon v-on="on">more_vert</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="showAllComments">
                        <v-list-item-title>Show All</v-list-item-title>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item v-for="snippet in snippets" @click="useSnippet(snippet)" :key="snippet.title">
                        <v-list-item-title>{{snippet.title}}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>  
        </div>
    </div>


    <div class="comment selectable hoverable" :class="{selected: comment.selected, important: comment.important}" 
        v-for="comment in comments" :key="comment.key"
        @click.exact="selectSingle(comment)" @click.shift="selectRange(comment)" @click.meta="selectMulti(comment)" @click.ctrl="selectMulti(comment)">
        <div class="indicator">

            <div style="float:right;margin-top:-1px;margin-right:-7px" @click.stop.prevent>
                <v-menu left offset-y>
                <template v-slot:activator="{ on }">    
                    <v-icon class="menu-icon" v-on="on">more_vert</v-icon>
                </template>
                <v-list>
                    <v-list-item @click="makeTask(comment)">
                        <v-list-item-title>Task Me Tomorrow</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="scheduleTask(comment)">
                        <v-list-item-title>Schedule Task</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="!comment.important" @click="makeImportant(comment)">
                        <v-list-item-title>Important</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-else @click="removeImportant(comment)">
                        <v-list-item-title>Not Important</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="editComment(comment)">
                        <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteComment(comment)">
                        <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                </v-list>
                </v-menu>

            </div>
            <v-icon v-if="comment.complete" small>check_circle_outline</v-icon>
            <span :class="{'comment-complete': comment.complete, 'comment-milestone':comment.milestone}" v-html="lineBreaks(comment.text)"></span>
            <span v-if="comment.complete">- Completed</span>

            <span class="grey--text text--lighten small-text">{{stamp(comment)}}</span>

        </div> 
    </div>
    <div class="grey--text" style="padding-left:12px" v-if="!allCommentsMode">
        {{comments.length || 'No'}} '{{commentType}}' comments 
        <a href="" @click.prevent="showAllComments">Show all</a>
    </div>
    <TaskDialog :task="taskDialog.model" :settings="taskDialog.settings" @save="saveTask" />


</div>
</template>

<script>
import { format, addDays, parse} from 'date-fns'

import PageHelpers from '../helpers/PageHelpers'
import DataHelpers from '../helpers/DataHelpers'
import StringHelpers from '../helpers/StringHelpers'
import NumberHelpers from '../helpers/NumberHelpers'
import ListHelpers from '../helpers/ListHelpers'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import Utilities from '../helpers/Utilities'
import DateHelpers from '../helpers/DateHelpers'
import LookupData from '../helpers/LookupData'
import TaskDialog from '../ui-elements/TaskDialog'



export default {

components: {
    TaskDialog,
}, 

data() {
    return {
        commentMenu: false,
        currentComment: {
            text: '' // 'this is @Mikaleigh task for #tomorrow'
        },
        members: ['Roxie Miles', 'grace.carroll', 'Mikaleigh'],
        hashtags: ['Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', 'Today', 'Tomorrow', 'OneWeek', ],
        taskDialog: {
            settings: {
                visible: false,
                title: 'Task Details',
            },
            model: {
                key: null,
                title: null,
                due: null,
                assigned: {},
            }
        }, 
    }
},

props: {
    firebaseRef: Object,
},

computed: {
    snippets() {
        return LookupData.snippets().filter(o => o.category == 'Comments')
    },
    searchText() {
        return PageHelpers.getPageData('search')
    },
    allCommentsMode() {
        return this.$store.getters.allCommentsMode
    },
    comments() {
        let comments =  this.$store.getters.transactionComments

        if(this.searchText) {
            return comments.filter(o => o.text.toLowerCase().indexOf(this.searchText) > -1)
        }

        if(this.allCommentsMode) {
            console.log('showing all comments')
            return comments
        }


        if(this.selectedTab && this.selectedTab.key == 'home')
            comments = comments.filter(o => o.important)
        else if(this.selectedTask)
            comments = comments.filter(o => o.taskKey == this.selectedTask.key)
        else if(this.selectedSection)
            comments = comments.filter(o => o.sectionKey == this.selectedSection.key)
        else if(this.selectedTab) {
            return comments.filter(o => (!o.tabKey || o.tabKey == this.selectedTab.key || o.important) )
        }

        return comments
    },

    selectedMentions() {
        return StringHelpers.mentions(this.currentComment.text)
    },

    selectedHashtags() {
        return StringHelpers.hashtags(this.currentComment.text)
    },

    selectedComments() {
        return this.comments.filter(o => o.selected)
    },

    commentType() {
        let commentType = 'General'
        if(this.selectedTask)
            commentType = StringHelpers.truncate(this.selectedTask.title || '', 25)
        else if(this.selectedSection)
            commentType = this.selectedSection.title
        else if(this.selectedTab)
            commentType = this.selectedTab.title

        if(commentType == 'Home')
            commentType = 'Important'
        return commentType
    },

    placeHolder() {
        if(this.searchText) {
            return "Containing '" + this.searchText + "'..."
        }
        const sectionTitle = this.commentType.toLowerCase()
        return `Comment for ${sectionTitle}...`
    },

    selectedTask() {
        return this.$store.getters.selectedTask
    },

    selectedSection() {
        return this.$store.getters.selectedSection
    },

    selectedTab() {
        return this.$store.getters.selectedTab
    },

    usersWithInitials() {
        return this.$store.getters.users.map(o => {
            return {
                ...o,
                initials: StringHelpers.acronym(o.name)
            }
        })
    },
},

methods: {

    useSnippet(snippet) {
        this.currentComment.text = snippet.text + ' '
        this.$refs.commentBox.$el.focus()
    },

    showAllComments() {
        this.$store.commit('allCommentsMode', true)
    },

    makeImportant(comment) {
        ListHelpers.selectedOrClicked(comment, this.selectedComments).forEach(comment => {
            let changes = {key: comment.key, important: true}
            this.$store.dispatch('saveTransactionComment', changes)
        })
    },
    makeTask(comment) {
        ListHelpers.selectedOrClicked(comment, this.selectedComments).forEach(comment => {
            let key = DataHelpers.getKey()
            let title = comment.text || ''

            let newTask = {key, title}
            this.$store.dispatch('saveTask', newTask)

            // later do we want to link new task back to comment?
            // this.$store.dispatch('saveTransactionComment', changes)
        })
    },
    saveTask(task) {
            this.$store.dispatch('saveTask', task)
    },
    scheduleTask(comment) {
        const dateStr = addDays(new Date(), 1).formatBackwards()
        
        this.taskDialog.model.due = dateStr
        this.taskDialog.model.title = comment.text
        this.taskDialog.model.assigned = DataHelpers.getUser()
        this.taskDialog.settings.visible = true
    },
    removeImportant(comment) {
        ListHelpers.selectedOrClicked(comment, this.selectedComments).forEach(comment => {
            let changes = {key: comment.key, important: null}
            this.$store.dispatch('saveTransactionComment', changes)
        })
    },

    editComment(comment) {
        this.currentComment = comment
        this.$refs.commentBox.$el.focus() //pass to native element focus
    },    

    deleteComment(comment) {
        ListHelpers.selectedOrClicked(comment, this.selectedComments).forEach(comment => {
            this.$store.dispatch('deleteTransactionComment', comment)
        })
    },    

    selectSingle(comment) {
        ListHelpers.selectSingle(comment, this.comments)

        let path = DataHelpers.getTransactionRef().toString() + `/comments/${comment.key}`

        Utilities.log('selectSingle', comment, path)
    },

    selectMulti(comment) {
        ListHelpers.selectMulti(comment)    
    },

    selectRange(comment) {
        ListHelpers.selectRange(comment, this.comments)
    },

    saveComment() {
        if(!this.currentComment || !this.currentComment.text || this.currentComment.text.length < 3)
            return

        let continueToSave = this.preProcessComment(this.currentComment.text) 
        
        let newComment = Object.assign({}, this.currentComment)

        const selectedTask = this.$store.getters.selectedTask
        
        Utilities.assignProperty(this.selectedTab, 'key', newComment, 'tabKey' )
        Utilities.assignProperty(this.selectedSection, 'key', newComment, 'sectionKey')
        Utilities.assignProperty(selectedTask, 'key', newComment, 'taskKey')

        if(this.selectedTab && this.selectedTab.key == 'home')
            newComment.important = true

        if(continueToSave)
            this.$store.dispatch('saveTransactionComment', newComment)

        Utilities.clearProperties(this.currentComment)
    },

    preProcessComment(text) {
        let initialsList = String(text).match(/@[A-Z][A-Z]\b/g) || []
        let continueToSave = true
        initialsList.forEach(initials => {
            let user = this.usersWithInitials.find(o => '@' + o.initials == initials)
            if(user) {
                let newTask = {
                    title: text, 
                    assigned: user,
                    due: DateHelpers.todayString(),
                }
                this.$store.dispatch('saveTask', newTask)
                continueToSave = false
            }
        })
        return continueToSave
    },

    loadComments() {
        for(let n = 1; n < 50; n++) {
            this.comments.push(this.makeRandomComment())
        }
    },

    makeRandomComment() {
        return {
            key: DataHelpers.getKey(),
            text: this.$faker().lorem.paragraph(3),
            stamp: DataHelpers.getStamp()
        }              
    },

    demoData() {
        this.currentComment.text = this.$faker().lorem.paragraph(2)
    },

    lineBreaks(str) {
        try {
            return str.replace(/\n/g, '<br/>')
        } catch (err) {
            console.error('lineBreaks was passed', err)
            return '[no value]'
        }
    },

    stamp(item) {
        let stampString = DataHelpers.formatStamp(item.stamp)
        return stampString
    },

},

created() {
    Utilities.log('comments > created')
    this.$store.dispatch('loadTransactionComments')
}
}
</script>

<style scoped>
.comment {
    margin-bottom: 6px;
    color:#444;
    border-radius: 2px;
    font-size: 1em;
}

.comment-milestone {
    font-weight: bold;
}

.hoverable:hover {
    background-color: #eee !important
}

.add-comment {
    height:32px;
    transition: height .2s ease-in-out
}

.add-comment:focus {
    height:70px;
}

</style>




// WEBPACK FOOTER //
// TransactionComments.vue?34d0505c